import React from 'react';

import type { Account } from '../../generated-types';
import { FormattedFuturePayment } from '../../utils/mapper/futurepaymentsUtil';
import FuturePaymentDetailsEFaktura from './FuturePaymentDetailsEFaktura';
import FuturePaymentDetailsPayment from './FuturePaymentDetailsPayment';
import FuturePaymentDetailsTransfer from './FuturePaymentDetailsTransfer';

interface Props {
    futurePayment: FormattedFuturePayment;
    onClose: () => void;
    hidePaymentButton: { value: boolean; set: (value: boolean) => void };
    account?: Account;
}

export default ({ futurePayment, ...rest }: Props) => {
    switch (futurePayment.paymentType) {
        case 'TRANSFER':
        case 'RECURRING_TRANSFER':
            return <FuturePaymentDetailsTransfer futurePayment={futurePayment} {...rest} />;
        case 'EFAKTURA':
            return <FuturePaymentDetailsEFaktura futurePayment={futurePayment} {...rest} />;
        default:
            return <FuturePaymentDetailsPayment futurePayment={futurePayment} {...rest} />;
    }
};
